var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEscalate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8.93 15.15C8.93 15.25 8.91 15.34 8.87 15.44C8.79 15.62 8.65 15.77 8.46 15.85C8.37 15.89 8.27 15.91 8.17 15.91C8.07 15.91 7.98 15.89 7.88 15.85C7.79 15.81 7.71 15.76 7.64 15.69L4.6 12.65C4.31 12.36 4.31 11.88 4.6 11.59C4.89 11.3 5.37 11.3 5.66 11.59L7.42 13.35V4.85C7.42 4.44 7.76 4.1 8.17 4.1C8.58 4.1 8.92 4.44 8.92 4.85V15.15H8.93ZM15.39 8.42C15.24 8.57 15.05 8.64 14.86 8.64C14.67 8.64 14.48 8.57 14.33 8.42L12.57 6.66V15.16C12.57 15.57 12.23 15.91 11.82 15.91C11.41 15.91 11.07 15.57 11.07 15.16V4.85C11.07 4.75 11.09 4.66 11.13 4.56C11.21 4.38 11.35 4.23 11.54 4.15C11.72 4.07 11.93 4.07 12.11 4.15C12.2 4.19 12.28 4.24 12.35 4.31L15.39 7.35C15.68 7.65 15.68 8.12 15.39 8.42Z",
    fill: "#455CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscalate);
export default __webpack_public_path__ + "static/media/Escalate.c83b0809.svg";
export { ForwardRef as ReactComponent };